import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomCompareArrows = (props: SvgIconProps): JSX.Element => {
    return (
        <SvgIcon {...props}>
            <path d="M6.75 21L1.5 15.375L6.75 9.75L8.22 11.3531L5.51625 14.25H13.05V16.5H5.51625L8.22 19.3969L6.75 21ZM17.25 14.25L15.78 12.6469L18.4837 9.75H14.7169H10.95V7.5H18.4837L15.78 4.60313L17.25 3L22.5 8.625L17.25 14.25Z" />
        </SvgIcon>
    );
};
